import $ from '../vendor/jquery';

$('.page-title .trigger').click(function(e) {
  e.stopPropagation();
  if ($('.page-title').hasClass('open')) {
    $('.page-title').removeClass('open');
    $('.sidebar-nav').hide();
  }
  else {
    $('.page-title').addClass('open');
    $('.sidebar-nav').show();
  }
});

$(document).click(function(){
  if ($('.page-title').hasClass('open')) {
    $('.page-title').removeClass('open');
    $('.sidebar-nav').hide();
  }
});



// WEBPACK FOOTER //
// ./public/assets/js/src/components/sidebar-nav.js